export default "__VITE_ASSET__Co4wA3ZQ__"